module.exports = __webpack_public_path__ + "fonts/source-sans-pro-v21-latin-700.4610010f.woff2";